import { useRouter } from "next/router";
import { handleGetVideoDataBySlug } from "../utils/constants/videoDetails";
const useRouting = () => {
  const router = useRouter();
  // const { isFacebookInAppBrowser, isInstagramInAppBrowser } =
  //   useBrowserDetect();

  const routeToLogin = () => {
    router.push("/login");
  };

  const routeToPremium = () => {
    router.push("/premium");
  };

  const routeToSeries = ({ slug, seriesId }) => {
    const routeTo = handleGetVideoDataBySlug({ slug });
    if (routeTo) router.push(`/details/${slug}`);
    else router.push(`/video/${slug}?muted=false`);
  };

  const routeToCategory = ({ slug }) => {
    router.push(`/category/${slug}`);
  };

  const routeToLoginConditionally = () => {
    // will be required in future
    // if (isFacebookInAppBrowser || isInstagramInAppBrowser) {
    //   window.location.href = "https://openinapp.link/pzq60";
    // } else {
    //   router.push("/login");
    // }
    router.push("/login");
  };

  return {
    routeToLogin,
    routeToPremium,
    routeToSeries,
    routeToCategory,
    routeToLoginConditionally,
  };
};

export default useRouting;
